import type { QueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Drops every cached query when the signed-in account ends or changes, so a
 * later sign-in on the same device can never be shown the previous person's
 * customers, jobs or documents from memory. Token refreshes and tab switches
 * for the SAME account leave the cache untouched.
 */
export function installAccountCacheGuard(queryClient: QueryClient): () => void {
  let currentUserId: string | null | undefined; // undefined = not yet known
  if (!supabase?.auth?.onAuthStateChange) return () => undefined; // partial test doubles only
  const { data } = supabase.auth.onAuthStateChange((event, session) => {
    const nextId = session?.user?.id ?? null;
    const changed =
      event === "SIGNED_OUT" ||
      (currentUserId !== undefined && currentUserId !== nextId);
    if (changed) queryClient.clear();
    currentUserId = nextId;
  });
  return () => data.subscription.unsubscribe();
}
